jQuery(function($) {


// doctor-search-form
// ===========================

$('#doctor-search-form select').change(function() {
    this.form.submit();
});

// ===========================
// end: doctor-search-form


// Vertical Rhythm
// ===========================
// window.onload = window.onresize = function () {
//     var grid = document.getElementsByClassName('c-VG');

//     if (document.body.clientHeight > window.innerHeight) {
//         grid[0].style.height = document.body.clientHeight + "px";
//     } else {
//         grid[0].style.height = '100%'; 
//     }
// };
// // ===========================
// end: Vertical Rhythm


//console.log(`scripts.js has loaded!`);

}(jQuery));